module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Circle-baa0c35b6ad5fecf8f029bff3000c696.svg";